import { PARTICIPANT_TYPES } from "@/service/mockValuesService";

export interface BaseMenuItem {
  label: string;
  icon: string;
}

export interface SimpleMenuItem extends BaseMenuItem {
  to: string;
  tooltip?: string;
}

export interface ExternalMenuItem extends BaseMenuItem {
  url: string;
  target: string;
}

export interface ParentMenuItem extends BaseMenuItem {
  items: MenuItem[];
  to?: string;
}

export type MenuItem = SimpleMenuItem | ExternalMenuItem | ParentMenuItem;

export function hasItems(item: MenuItem): item is ParentMenuItem {
  return "items" in item;
}

export function isExternal(item: MenuItem): item is ExternalMenuItem {
  return "url" in item;
}

const participantItems = Object.values(PARTICIPANT_TYPES).map((type) => ({
  label: type.title,
  icon: type.icon,
  to: `/backoffice/participants/${type.title.toLowerCase()}`,
  tooltip: type.title,
}));

const menu: MenuItem[] = [
  {
    label: "Participants",
    icon: "pi pi-users",
    items: [...participantItems],
  },
  {
    label: "Groups",
    icon: "pi pi-users",
    to: "/backoffice/groups",
    items: [
      {
        label: "Groups",
        icon: "pi pi-users",
        to: "/backoffice/groups",
      },
    ],
  },

  {
    label: "aid",
    icon: "pi pi-heart",
    items: [
      {
        label: "Accounts",
        icon: "pi pi-money-bill",
        to: "/backoffice/aid/chart-of-accounts",
      },
      {
        label: "Projects",
        icon: "pi pi-briefcase",
        to: "/backoffice/aid/projects",
      },
      {
        label: "Project Settings",
        icon: "pi pi-sitemap",
        to: "/backoffice/aid/project-settings",
      },
    ],
  },

  {
    label: "Bank",
    icon: "pi pi-building",
    items: [
      {
        label: "Accounts",
        icon: "pi pi-briefcase",
        to: "/backoffice/bank/bank-accounts",
      },
      {
        label: "Products",
        icon: "pi pi-money-bill",
        to: "/backoffice/bank/bank-products-list",
      },
      {
        label: "Journals",
        icon: "pi pi-money-bill",
        to: "/backoffice/bank/journals",
      },
    ],
  },
  {
    label: "Payments",
    icon: "pi pi-money-bill",
    to: "/backoffice/journal",
    items: [
      {
        label: "Vouchers",
        icon: "pi pi-ticket",
        to: "/backoffice/payments/vouchers",
      },
      {
        label: "MPesa",
        icon: "pi pi-book",
        to: "/backoffice/mpesa",
      },
    ],
  },
  {
    label: "Organization",
    icon: "pi pi-sitemap",
    to: "/backoffice/organization",
    items: [
      {
        label: "Locations",
        icon: "pi pi-building",
        to: "/backoffice/organization/manage-locations",
      },
      {
        label: "Employees",
        icon: "pi pi-users",
        to: "/backoffice/organization/manage-employees",
      },
      {
        label: "Holidays",
        icon: "pi pi-calendar",
        to: "/backoffice/organization/manage-holidays",
      },
      {
        label: "Currencies",
        icon: "pi pi-money-bill",
        to: "/backoffice/organization/currency-configuration",
      },
      {
        label: "Self Service",
        icon: "pi pi-user-edit",
        to: "/backoffice/organization/self-service",
      },
    ],
  },

  {
    label: "Replenishment",
    icon: "pi pi-refresh",
    items: [
      {
        label: "Cron Schedule",
        icon: "pi pi-clock",
        to: "/backoffice/replenishment/cron-schedule",
      },
      {
        label: "Programs",
        icon: "pi pi-list",
        to: "/backoffice/replenishment/programs",
      },
    ],
  },

  {
    label: "Settings",
    icon: "pi pi-cog",
    to: "/backoffice/general-ledger",
    items: [
      {
        label: "Fields",
        icon: "pi pi-code",
        to: "/backoffice/settings/manage-codes",
      },
    ],
  },
];

export default menu;
